// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h1 style={{ 'margin-top': '0' }}>
        Explore
      </h1>
      <p>Check out our documentation for available APIs:</p>
      <ul>
      <li><a href="/explore/benefits">Benefits API</a></li>
      <li><a href="/explore/facilities">Facilities API</a></li>
      <li><a href="/explore/health">Health API</a></li>
      <li><a href="/explore/verification">Veteran Verification API</a></li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
